import { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import SignaturePad from 'react-signature-canvas'
import '../formcomponents/ElectronicSignature.css'
import IformBreadcrumb from '../formcomponents/iformBreadcrumb'
import { Typography, Button, Link } from '@nwh-consumer-digital/nw-component-lib'
import ErrorMessage from '../formcomponents/errorMessage'
import { Grid, Box, Paper, Stack, useMediaQuery } from '@mui/material'
import styled from '@emotion/styled'
import { useProgress } from '../context/ProgressContext'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fal, faCircleExclamation } from '@fortawesome/pro-light-svg-icons'
library.add(fal, faCircleExclamation)

const Item = styled(Paper)(({ theme }) => ({
  textAlign: 'left',
  minHeight: '65px',
  lineHeight: '60px',
}))

const styles = {
  signatureSectionCont: {
    padding: '10px',
  },
  errorMsgCont: {
    display: 'grid',
    clear: 'both',
    width: '100%',
    paddingTop: '40px',
  },
}

const thirteenToSeventeenPageThree = (props) => {
  const { updateProgress } = useProgress()
  updateProgress(75)
  const isMobile = useMediaQuery('(max-width:600px)')

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  // Scroll to top when page mounts
  useEffect(() => {
    scrollToTop()
  }, [])

  // Setup Ref for Signature Pad Container and Handle Error States  const cardRef = useRef(null)
  const cardRef = useRef(null)

  const removeBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '1px solid #cccccc'
    }
  }
  const addBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '3px solid red'
    }
  }

  const handleSignature = () => {
    setTimeout(() => {
      setIsSigned(true)
    }, 300)
    removeBottomBorderRed()
  }

  const { SubmissionState, onFormStateChange } = props
  const { register, handleSubmit, setValue } = useForm()
  const [isSigned, setIsSigned] = useState(false)
  const [imageURL, setImageURL] = useState(null)
  const signData = useRef({})

  const proxyAccessLevel = SubmissionState.sectionTwoForm?.proxyAccessLevel
  const proxyName =
    SubmissionState.sectionTwoForm?.firstNameGuardian + ' ' + SubmissionState.sectionTwoForm?.lastNameGuardian

  const setCardColor = (color) => {
    const sigPadElements = document.getElementsByClassName('SigPad')
    if (sigPadElements[0]) {
      sigPadElements[0].style.backgroundColor = color
    }
    if (cardRef.current) {
      cardRef.current.style.backgroundColor = color
    }
  }

  const clear = () => {
    setImageURL('reset')
    addBottomBorderRed()
    setIsSigned(false)
    signData.current.clear()
    setCardColor('#FAFAFA')
  }

  const save = () => {
    const dataUrl = signData.current.getTrimmedCanvas().toDataURL('image/png')
    setImageURL(dataUrl)
    setValue('imageURLStr', 'True')
    setCardColor('#E8F0FE')
    setIsSigned(true)
  }

  const saveIfNotEmpty = () => {
    if (signData.current.isEmpty()) {
      setIsSigned(false)
    } else {
      save()
    }
  }

  const handleRegistration = (data) => {
    if (imageURL) {
      setValue('imageURLStr', 'True')
      setIsSigned(true)
    }

    data.imageUrl = imageURL
    data.uploadFiles = 'See Folder Images'
    SubmissionState.sec = data
    SubmissionState.sectionThreeForm = data
    SubmissionState.sectionThreSubmitted = true
    SubmissionState.goBackPageOne = false
    SubmissionState.goBackPageTwo = false
    SubmissionState.goBackLogin = false
    SubmissionState.goPageFour = true
    SubmissionState.submitCompletedForm = false
    onFormStateChange()
  }

  const previousPageClick = () => {
    SubmissionState.showPageThree = false
    SubmissionState.showPageTwo = true
    SubmissionState.goBackPageTwo = true
    SubmissionState.goPageThree = false
    onFormStateChange()
  }

  return (
    <Box>
      <Grid container spacing={1} justifyContent="space-between" alignItems="left">
        <Grid
          item
          xs={12}
          sx={{
            marginTop: {
              xs: '1.25rem',
              sm: '1.25rem',
              md: '1.25rem',
              lg: '2rem',
              xl: '2rem',
            },
            marginBottom: {
              xs: '2rem',
              sm: '2rem',
              md: '2rem',
              lg: '2rem',
              xl: '2rem',
            },
          }}>
          <IformBreadcrumb onClick={previousPageClick}>&lt; Requestor's Information</IformBreadcrumb>
        </Grid>
        <Grid item xs={12} sm={6} md={12}>
          <Item elevation={0}>
            <Typography variant="h1" style={{ marginBottom: 24 }}>
              For Teen
            </Typography>
          </Item>
          <Item elevation={0}>
            <Typography variant="h2" style={{ marginLeft: -4, marginBottom: 16, fontSize: 20 }}>
              By signing below, I wish to grant the Proxy named above with limited access. limited access, and I
              acknowledge and agree that:{' '}
            </Typography>
          </Item>
          <Item elevation={0}>
            <Typography type="body" size="large" weight="light">
              <ul>
                <li>
                  I must comply with the Terms and Conditions on the MyNorthwell Website to access my MyNorthwell
                  account.
                </li>
                <li>
                  The person I picked as my Proxy will have access to my MyNorthwell account, in the manner specified
                  above, which includes access to my medical information that is currently available and that will be
                  put in MyNorthwell for future medical care.
                </li>
                <li>My Proxy may have access to medical information that I wish to keep confidential.</li>
                <li>
                  I can stop my Proxy from seeing my medical information at any time by visiting the “Share My Record”
                  tab in my MyNorthwell account menu, selecting “Friend and family access,” and clicking the “Revoke”
                  button next to my Proxy’s name. I can also send an email to:{' '}
                  <Link
                    hrefLink="mailto:northwellproxy@northwell.edu"
                    target="new"
                    linkText="northwellproxy@northwell.edu"
                  />{' '}
                  to ask for this change.
                </li>
                <li>
                  Unless I revoke my Proxy’s access, my Proxy will continue to have access to my MyNorthwell account
                  until my 18th birthday.
                </li>
                <li>
                  Once my medical information is shared with my Proxy, it may be re- disclosed and it may no longer be
                  protected by federal and state privacy laws.
                </li>
              </ul>
            </Typography>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h2" style={{ marginLeft: -10, marginBottom: 16, fontSize: 20 }}>
            By signing below, I grant{' '}
            <Typography component="span" style={{ fontSize: 20, fontWeight: 'bold' }}>
              {proxyName}, limited access
            </Typography>{' '}
            to MyNorthwell account.
          </Typography>
        </Grid>
        <form onSubmit={handleSubmit(handleRegistration)}>
          <Grid item xs={12}>
            <Item elevation={0}>
              <div className="Card" ref={cardRef}>
                <Typography type="body" size="small" weight="plain" style={{ marginTop: 10, marginLeft: 16 }}>
                  {' '}
                  Signature required<span className="red"> *</span>
                </Typography>
                <div className="SigContainer">
                  <SignaturePad
                    onEnd={handleSignature}
                    penColor="black"
                    canvasProps={{ className: 'SigPad' }}
                    ref={signData}
                  />
                  <div>{!isSigned ? <ErrorMessage message="Patient's signature is required." /> : null}</div>
                  <Stack spacing={2} direction={isMobile ? 'column' : 'row'}>
                    <Button size="medium" color="primary" onClick={saveIfNotEmpty} type="submit" text="Submit" />
                    <Button size="medium" color="secondary" onClick={clear} type="button" text="Reset Signature" />
                  </Stack>
                </div>
              </div>
              <input {...register('imageURLStr', { required: true })} type="hidden" />
              <div style={styles.errorMsgCont}></div>
            </Item>
          </Grid>
        </form>
      </Grid>
    </Box>
  )
}

export default thirteenToSeventeenPageThree
